<template>
  <svg
    viewBox="0 0 16 16"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <rect
      x="2.5"
      y="3.5"
      width="11"
      height="10"
      rx="2" />
    <path d="M2.5 7h11M5.5 2v3M10.5 2v3" />
  </svg>
</template>
